import { Typography } from '@navi/web-ui/lib/primitives';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchSingleMockRunDetails,
  updateMockRunStatus
} from '../../../actions/FieldAllocationAction';
import StepsButton from '../StepsButton';
import { RadioGroup } from '@navi/web-ui/lib/components';
import { readQueryParams } from '@cp/src/utils/QueryParamsHelper';
import { AGENCY_CAPPING_OPTIONS, FIELD_ALLOCATION_KEY, MockTriggerType } from '../../../types';
import { UpdateMockRunStatusPayload } from '../../../actions/interface';
import { toast } from '@navi/web-ui/lib/primitives/Toast';
import { RootState } from '@cp/src/store';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { SELF_SERVE_UI_CLICKSTREAM } from '@cp/src/service/clickStream.constant';

interface ITriggerMockConfirmationStepProps {
  handleCloseModal: () => void;
}

const TriggerMockConfirmationStep: React.FC<ITriggerMockConfirmationStepProps> = ({
  handleCloseModal
}) => {
  const dispatch = useDispatch();
  const queryParams = readQueryParams();
  const [agencyCappingState, setAgencyCappingState] = useState('');
  const selectedMockId = queryParams[FIELD_ALLOCATION_KEY]?.selectedId;
  const updateMockRunStatusLoading = useSelector(
    (state: RootState) => state.fieldAllocation?.updateMockRunStatusLoading
  );
  const successCallBack = () => {
    handleCloseModal();
    dispatch(fetchSingleMockRunDetails(selectedMockId));
    toast('Mock allocation triggered', { type: 'success' });
  };

  const onConfirm = () => {
    const payload: UpdateMockRunStatusPayload = {
      status: MockTriggerType.TRIGGER,
      allocationTrackerId: selectedMockId,
      agencyCapping: agencyCappingState === 'true'
    };
    dispatch(updateMockRunStatus(payload, successCallBack));
  };

  const handleRadioChange = (value: string) => {
    addClickstreamEvent(SELF_SERVE_UI_CLICKSTREAM.LH_AGENCY_CAPPING_TOGGLE_CLICKED, {
      mockId: selectedMockId,
      newCappingStatus: agencyCappingState === 'true' ? 'Included' : 'Excluded'
    });
    setAgencyCappingState(value);
  };

  return (
    <>
      <Typography variant="h4" color="var(--navi-color-gray-c2)" className="max-w-[300px]">
        This process can take up-to <b>3 hours</b> and cannot be cancelled once processed!
      </Typography>
      <div className="flex justify-between items-center mt-8">
        <Typography variant="h4" color="var(--navi-color-gray-c2)">
          Agency capping
        </Typography>
        <RadioGroup
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            handleRadioChange(e.target.value);
          }}
          value={agencyCappingState}
          name="agencyCapping"
          options={AGENCY_CAPPING_OPTIONS}
          disabled={updateMockRunStatusLoading}
        />
      </div>
      <StepsButton
        onCancel={handleCloseModal}
        onAction={onConfirm}
        actionText="Confirm (2/2)"
        disabled={agencyCappingState === ''}
        isLoading={updateMockRunStatusLoading}
      />
    </>
  );
};

export default TriggerMockConfirmationStep;
